import { NavbarWrapper } from "./styles";
import {
  Link,
  Element,
  Events,
  animateScroll as scroll,
  scroller,
} from "react-scroll";
import Logo from "../../assets/logos/1.svg";

const Navbar = () => {
  return (
    <>
      <NavbarWrapper className="navbar navbar-expand-lg navbar-light fixed-top">
        <div className="app-container container-fluid">
          <Link
            activeClass="active"
            className="test1 navbar-brand"
            to="home"
            spy={true}
            smooth={true}
            duration={200}
          >
            <img src={Logo} alt="logo" />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav" style={{ marginLeft: "auto" }}>
              <li className="nav-item">
                <Link
                  activeClass="active"
                  className="test1 nav-link"
                  to="home"
                  spy={true}
                  smooth={true}
                  duration={200}
                >
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  activeClass="active"
                  className="test1 nav-link"
                  to="about"
                  spy={true}
                  smooth={true}
                  duration={200}
                >
                  About
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  activeClass="active"
                  className="test1 nav-link"
                  to="services"
                  spy={true}
                  smooth={true}
                  duration={200}
                >
                  Services
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  activeClass="active"
                  className="test1 nav-link"
                  to="projects"
                  spy={true}
                  smooth={true}
                  duration={200}
                >
                  Projects
                </Link>
              </li>
              <li className="nav-item">
                <button className="btn btn-primary">
                  <Link
                    activeClass="active"
                    className="test1"
                    to="contact"
                    spy={true}
                    smooth={true}
                    duration={200}
                  >
                    Contact Us
                  </Link>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </NavbarWrapper>
      <div style={{ height: "60px" }} />
    </>
  );
};

export default Navbar;
